/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};

export { labelNext };
//# sourceMappingURL=labelNext.js.map
